import React from "react";

import { loginHandoffContent } from "../content/loginHandoff";
import type { Locale } from "../content/types";
import { SamlWidgetLogin } from "./SamlWidgetLogin";

type LoginHandoffProps = {
  locale: Locale;
};

export function LoginHandoff({ locale }: LoginHandoffProps) {
  const content = loginHandoffContent[locale];
  const link = content.links[0];
  if (!link) {
    return null;
  }

  return (
    <section className="db-section section-band login-handoff" id="login-handoff" aria-labelledby="login-handoff-title">
      <div className="db-container login-handoff__inner">
        <svg className="login-handoff__art" viewBox="0 0 360 220" aria-hidden="true" focusable="false">
          <defs>
            <linearGradient id="login-handoff-gradient-a" x1="0" x2="1" y1="0" y2="1">
              <stop offset="0%" stopColor="#1f7a8c" />
              <stop offset="48%" stopColor="#2f5f98" />
              <stop offset="100%" stopColor="#c67a3f" />
            </linearGradient>
            <linearGradient id="login-handoff-gradient-b" x1="1" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#8cd8f4" />
              <stop offset="100%" stopColor="#f0b36b" />
            </linearGradient>
          </defs>
          <path className="login-handoff__art-path login-handoff__art-path--a" d="M26 132 C86 20 154 202 226 78 C268 5 315 48 342 116" />
          <path className="login-handoff__art-path login-handoff__art-path--b" d="M18 176 C78 110 142 140 181 110 C230 72 278 96 340 42" />
          <circle className="login-handoff__art-dot login-handoff__art-dot--a" cx="86" cy="82" r="8" />
          <circle className="login-handoff__art-dot login-handoff__art-dot--b" cx="244" cy="84" r="10" />
          <circle className="login-handoff__art-dot login-handoff__art-dot--c" cx="300" cy="132" r="6" />
        </svg>

        <div className="login-handoff__copy">
          <p className="section-eyebrow">{content.eyebrow}</p>
          <h2 id="login-handoff-title">{content.title}</h2>
          <p>{content.lead}</p>
          <p>{content.boundary}</p>
        </div>

        <div className="login-handoff__cta" aria-label={content.title}>
          <div>
            <h3>{link.label[locale]}</h3>
            <p>{link.body[locale]}</p>
          </div>
          <SamlWidgetLogin
            locale={locale}
            fallbackHref={link.href[locale]}
            label={link.label[locale]}
            className="db-button db-button--primary"
          />
        </div>
      </div>
    </section>
  );
}
